import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ForcePaddingSemantic_getInstance2mi5o79ljh5pc as ForcePaddingSemantic_getInstance } from '../../models/Theme.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../ViewWrapper.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SizeConstraints24axz83pb17aw as SizeConstraints } from '../../models/data.mjs';
import {
  sizedBox1c7jm55crxo9r as sizedBox,
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from './modifiers.commonHtml.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from './ScrollView.commonHtml.js.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_padded(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.lba(_this__u8e3s4.qb6_1.abf(ForcePaddingSemantic_getInstance()));
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function sizeConstraints(_this__u8e3s4, minWidth, maxWidth, minHeight, maxHeight, aspectRatio, width, height) {
  minWidth = minWidth === VOID ? null : minWidth;
  maxWidth = maxWidth === VOID ? null : maxWidth;
  minHeight = minHeight === VOID ? null : minHeight;
  maxHeight = maxHeight === VOID ? null : maxHeight;
  aspectRatio = aspectRatio === VOID ? null : aspectRatio;
  width = width === VOID ? null : width;
  height = height === VOID ? null : height;
  return sizedBox(_this__u8e3s4, new (SizeConstraints())(minWidth, maxWidth, minHeight, maxHeight, aspectRatio, width, height));
}
function get_scrollingHorizontally(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var vertical = false;
  var horizontal = true;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical);
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function get_unpadded(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    _this__u8e3s4.gba(get_px(0));
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function get_scrolling(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var vertical = true;
  var horizontal = false;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical);
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function get_scrollsHorizontally(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var vertical = false;
  var horizontal = true;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.dbb_1;
  var tmp = _this__u8e3s4;
  tmp.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical);
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
function gravity(_this__u8e3s4, horizontal, vertical) {
  return align(_this__u8e3s4, horizontal, vertical);
}
function onlyWhen(_this__u8e3s4, default_0, condition) {
  default_0 = default_0 === VOID ? false : default_0;
  return shownWhen(_this__u8e3s4, default_0, condition);
}
//region block: exports
export {
  gravity as gravity24js74359tyjo,
  onlyWhen as onlyWhen1gzwe00zqrj87,
  get_padded as get_padded3m3frjnjujncx,
  get_scrolling as get_scrolling27q1yr4ng0cx8,
  get_scrollingHorizontally as get_scrollingHorizontally3ifk3kuuwhjjn,
  get_scrollsHorizontally as get_scrollsHorizontally166yklfalehnr,
  sizeConstraints as sizeConstraints2hv7x4j4qpd36,
  get_unpadded as get_unpadded3gipn3ftxgnwh,
};
//endregion

//# sourceMappingURL=modifiers.mjs.map
